<template>
  <div class="account-poll-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <star-condition-cell label="账号类型">
        <a-select v-model="searchCondition.type" style="width: 100%" allowClear>
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="账号状态">
        <a-select v-model="searchCondition.status" style="width: 100%" allowClear>
          <a-select-option :value="-1"> 停用 </a-select-option>
          <a-select-option :value="0"> 可用 </a-select-option>
          <a-select-option :value="1"> 正在使用 </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="用户昵称">
        <a-input v-model="searchCondition.accountName" style="width: 100%" allowClear></a-input>
      </star-condition-cell>

      <star-condition-cell label="用户ID">
        <a-input v-model="searchCondition.account" style="width: 100%" allowClear></a-input>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary"  @click="showCreate">新建</a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="accountPoolId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="type" slot-scope="label">
          {{ toClassName(label) }}
        </span>

        <span slot="status" slot-scope="label">
          {{ toStatusName(label) }}
        </span>

        <span slot="action" slot-scope="_, record">
          <a-popconfirm
            v-if="record.status !== -1"
            title="禁用将无法使用该账号执行任务，是否确认禁用？"
            @confirm="() => onChangeStatus(record, -1)"
          >
            <a-button type="link">禁用 </a-button>
          </a-popconfirm>
          <a-popconfirm
            v-else
            title="当前账号为异常账号，是否确认解除禁用？"
            @confirm="() => onChangeStatus(record, 0)"
          >
            <a-button type="link">解除禁用 </a-button>
          </a-popconfirm>

          <a-divider type="vertical"></a-divider>
          <a-button type="link" @click="showModify(record)">编辑 </a-button>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="确定要删除吗，删除后将无法使用?"
            @confirm="() => handleDelete(record)"
          >
            <a-button type="link">删除 </a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <CreateAndModify
      :visible="isShowCreateAndModify"
      :isModify="isModalModifMod"
      :confirmLoading="createAndModifyLoading"
      :handleOk="isModalModifMod ? onModify : onCreate"
      :handleCancel="() => (isShowCreateAndModify = false)"
      :createAndModifyData.sync="createAndModifyData"
      :spiderClassOptions="spiderClassOptions"
      :data="createAndModifyData"
    />
  </div>
</template>

<script>
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent, onHttpResponse } from '@/utils/request'
import {
  getAccountPoolApi,
  deleteAccountPoolApi,
  createAccountPoolApi,
  modifyAccountPoolApi,
  modifyAccountPoolStatusApi
} from '@/api/Dispatch/Account/index'

import CreateAndModify from './CreateAndModify'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  mixins: [tableSettingToStoreMixin()],
  components: { CreateAndModify },
  data() {
    return {
      loading: false,
      searchCondition: {
        type: '',
        status: '',
        accountName: '',
        account: ''
      },
      spiderClassOptions: [],

      tableDensity: 'middle',
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableData: [],
      columns: [
        {
          width: 80,
          title: '序号',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        // {
        //   title: '连接池id',
        //   dataIndex: 'accountPoolId',
        //   show: true,
        //   align: 'center'
        // },
        {
          title: '账号名',
          dataIndex: 'accountName',
          show: true,
          align: 'center'
        },
        {
          title: '账号名',
          dataIndex: 'account',
          show: true,
          align: 'center'
        },
        {
          title: '密码',
          dataIndex: 'password',
          show: true,
          align: 'center'
        },
        {
          title: '账号状态',
          dataIndex: 'status',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '最近使用时间',
          dataIndex: 'useTime',
          show: true,
          align: 'center'
        },
        {
          title: '类别',
          dataIndex: 'type',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 240,
          align: 'center'
        }
      ],

      isShowCreateAndModify: false,
      isModalModifMod: false,
      createAndModifyLoading: false,
      createAndModifyData: {
        type: '',
        accountName: '',
        account: '',
        password: '',
        accessToken: '', // 账号秘钥
        accessSecret: '' // 秘钥密码
      }
    }
  },

  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  mounted() {
    this.querySpiderClassInfo()
    this.handleSearch()
  },

  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.getTableData()
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableData()
    },

    getTableData() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchCondition
      }
      this.loading = true
      getAccountPoolApi(query)
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.tableData = data
          this.pagination.total = extra.page.pageCount || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    reset() {
      this.searchCondition = {
        type: '',
        status: '',
        accountName: '',
        account: ''
      }
      this.handleSearch()
    },

    querySpiderClassInfo() {
      let doneTypes = ['twitter', 'weibo']
      querySpiderClassInfoApi()
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.spiderClassOptions = data.filter((d) => doneTypes.includes(d.type))
        })
    },

    toClassName(type) {
      let tar = this.spiderClassOptions.filter((s) => s.type === type)[0]
      if (tar) {
        return tar.spiderClassName
      }
      return ''
    },

    toStatusName(type) {
      switch (type) {
        case -1:
          return '停用'
        case 0:
          return '可用'
        case 1:
          return '正在使用'
        default:
          return '---'
      }
    },

    handleDelete(record) {
      deleteAccountPoolApi(record.accountPoolId).then(onHttpResponse).then(this.getTableData)
    },

    showCreate() {
      this.createAndModifyData = {
        type: '',
        accountName: '',
        account: '',
        password: '',
        accessToken: '',
        accessSecret: ''
      }
      this.isModalModifMod = false
      this.isShowCreateAndModify = true
    },

    showModify(record) {
      this.createAndModifyData = { ...record }
      this.isModalModifMod = true
      this.isShowCreateAndModify = true
    },

    onCreate(createData) {
      this.createAndModifyLoading = true
      createAccountPoolApi(createData)
        .then(onHttpResponse)
        .then(this.getTableData)
        .then(() => {
          this.isShowCreateAndModify = false
        })
        .catch(() => {})
        .finally(() => {
          this.createAndModifyLoading = false
        })
    },

    onModify(modifyData) {
      this.createAndModifyLoading = true
      modifyAccountPoolApi(modifyData)
        .then(onHttpResponse)
        .then(this.getTableData)
        .then(() => {
          this.isShowCreateAndModify = false
        })
        .catch(() => {})
        .finally(() => {
          this.createAndModifyLoading = false
        })
    },

    onChangeStatus(record, status) {
      modifyAccountPoolStatusApi({ ...record, status })
        .then(onHttpResponse)
        .then(this.getTableData)
    }
  }
}
</script>

<style lang="less" scoped>
.account-poll-container {
  width: 100%;
  padding: 16px;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
